import React from "react"

export default function SwitchOff() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="39" height="25" viewBox="0 0 39 25" fill="none">
         <rect x="2.64258" y="0.896484" width="35" height="19" rx="9.5" fill="white" stroke="#EEEEEE" />
         <g filter="url(#filter0_d_156_4545)">
            <circle cx="12.1426" cy="10.3965" r="8" fill="white" />
         </g>
         <defs>
            <filter id="filter0_d_156_4545" x="0.142578" y="0.396484" width="24" height="24" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
               <feFlood floodOpacity="0" result="BackgroundImageFix" />
               <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
               <feOffset dy="2" />
               <feGaussianBlur stdDeviation="2" />
               <feColorMatrix type="matrix" values="0 0 0 0 0.631373 0 0 0 0 0.647059 0 0 0 0 0.67451 0 0 0 0.29 0" />
               <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_156_4545" />
               <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_156_4545" result="shape" />
            </filter>
         </defs>
      </svg>
   )
}
